import { Checkbox, FormControlLabel } from "@mui/material";
import { MethodSettingsProps } from "../shared";

//TODO: Make a shared WL component across all 3
export const DefaultVSpinSettings = ({
  externalThawInternalState,
  handleMethodSettingsChanged,
}: MethodSettingsProps) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={
            externalThawInternalState.methodSettings.defaultVSpinSettings
          }
          onChange={(e) =>
            handleMethodSettingsChanged(
              "defaultVSpinSettings",
              e.target.checked
            )
          }
          size="small"
        />
      }
      label={"Enable Default VSpin Settings?"}
    />
  );
};

export const DefaultVSpinSettingsDict = new Map<string, number>([
  ["spinParamGForce", 252],
  ["spinParamPercent", 50],
  ["spinTime", 6],
  ["spinAccel", 50],
  ["spinDecel", 5],
]);
